export default __webpack_public_path__ + "static/media/gallery11.9171546c.jpg";